<template>
	<section class="main-content align-center background-color">
		<div class="row faq">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div v-for="item in items" :key="item.ID" class="columns column12 faq-item">
					<collapse :header="item.question" :content="item.answer" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.faq-item {
	text-align: center;
	font-size: 0;
}

h2 {
	margin-bottom: 50px;
}
</style>
